import { RegistroItemComponent } from './../components/registro-item/registro-item.component';
import { NgModule } from '@angular/core';
import { NbAccordionModule, NbActionsModule, NbAutocompleteModule, NbButtonModule, NbCardModule, NbDatepickerModule, NbIconModule, NbInputModule, NbLayoutModule, NbListModule, NbMenuModule, NbSelectModule, NbSpinnerModule, NbTabsetModule, NbTagModule, NbToastrModule, NbToggleModule, NbTooltipModule } from '@nebular/theme';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import { ThemeModule } from '../@theme/theme.module';
import { PagesComponent } from './pages.component';
import { DashboardModule } from './dashboard/dashboard.module';
import { PagesRoutingModule } from './pages-routing.module';
import { VisorSigpacComponent } from './visor-sigpac/visor-sigpac.component';
import { FormsModule } from '@angular/forms';
import { LoginComponent } from './login/login.component';
import { VisorDiarioComponent } from './visor-diario/visor-diario.component';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { CellDatepickerComponent } from './visor-diario/cell-datepicker/cell-datepicker.component';
import { NbDateFnsDateModule } from '@nebular/date-fns';
import { NbMomentDateModule } from '@nebular/moment';
import { CellCultivoComponent } from './visor-diario/cell-cultivo/cell-cultivo.component';
import { CellUnidadComponent } from './visor-diario/cell-unidad/cell-unidad.component';
import { AdsenseModule } from 'ng2-adsense';
import { AyudaComponent } from './ayuda/ayuda.component';
import { SimpleNgAdsenseModule } from 'app/simple-ng-adsense/simple-ng-adsense.module';
import { MapViewerComponent } from 'app/components/map-viewer/map-viewer.component';
import { RegistroItemComponent2 } from './visor-diario/registro-item/registro-item.component';
import { ExplotacionComponent } from './explotacion/explotacion.component';
import {ItemCellEditorComponent} from './../components/item-cell-editor/item-cell-editor.component';
import { MachineryCellEditorComponent } from 'app/components/item-cell-editor/machinery-cell-editor.component';
import { AdvisorsAppliersCellEditorComponent } from 'app/components/item-cell-editor/advisorsappliers-cell-editor.component';
import { CategoryAdvisorsAppliersCellEditorComponent } from 'app/components/item-cell-editor/categoryadvisorsappliers-cell-editor.component';
import {ItemCellRenderComponent} from './../components/item-cell-editor/item-cell-render.component';
import { RegistroEditorComponent } from './visor-diario/registro-editor/registro-editor.component';
import { ItemSelectorComponent } from 'app/components/item-selector/item-selector.component';

import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { EquipoAplicadorComponent } from './visor-diario/equipo-aplicador/equipo-aplicador.component';
import { ItemSearchableComponent } from 'app/components/item-searchable/item-searchable.component';
import { ComposicionProductoComponent } from './visor-diario/composicion-producto/composicion-producto.component';

@NgModule({
  imports: [
    PagesRoutingModule,
    ThemeModule,
    NbMenuModule,
    DashboardModule,
    NbCardModule,
    NbLayoutModule,
    NbActionsModule,
    NbIconModule,
    NbInputModule,
    NbButtonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    NbTabsetModule,
    NbListModule,
    Ng2SmartTableModule,
    NbDatepickerModule,
    NbMomentDateModule,
    NbSelectModule,
    NbAutocompleteModule,
    NbSpinnerModule,
    NbToastrModule.forRoot(),
    NbAccordionModule,
    NbTooltipModule,
    NbToggleModule,

    SimpleNgAdsenseModule.forRoot({adClient: 'ca-pub-5788122964860609'}),

    NgMultiSelectDropDownModule,
    NbTagModule,
  ],
  declarations: [
    PagesComponent,
    VisorSigpacComponent,
    LoginComponent,
    VisorDiarioComponent,
    CellDatepickerComponent,
    CellCultivoComponent,
    CellUnidadComponent,
    AyudaComponent,
    MapViewerComponent,
    RegistroItemComponent,
    RegistroItemComponent2,
    ExplotacionComponent,
    ItemCellEditorComponent,
    MachineryCellEditorComponent,
    AdvisorsAppliersCellEditorComponent,
    CategoryAdvisorsAppliersCellEditorComponent,
    ItemCellRenderComponent,
    RegistroEditorComponent,
    ItemSelectorComponent,
    EquipoAplicadorComponent,
    ItemSearchableComponent,
    ComposicionProductoComponent,
  ],
  entryComponents: [
    CellDatepickerComponent,
    CellCultivoComponent,
    CellUnidadComponent,
  ],
})
export class PagesModule {
}
